export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigung erforderlich"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autorisierung muss mit einem einmaligen Schlüssel bestätigt werden"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autorisierung muss mit dem magischen Wort bestätigt werden"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registrierung muss mit einem SMS-Code bestätigt werden"])}
}